import { log } from "../../app";

let nativePaymentOptions,
  stripePaymentRequest,
  stripePaymentRequestLabel,
  stripePaymentRequestAmount,
  stripePaymentType;

// Map standard offers seen on /subscribe page to their data.
// Not necessary for offers that don't appear on /subscribe.
// TODO read this data out of Stripe database rather than hardcoding here
const planDataObj = {
  monthly59: {
    amount: 5900,
    label: 'Monthly Pro Subscription',
  },
  monthly: {
    amount: 3900,
    label: 'Monthly Subscription',
  },
  monthly_44_99: {
    amount: 4499,
    label: 'Monthly Subscription',
  },
  'monthly-30-day-trial': {
    amount: 0,
    label: '30-Day Free Trial, Then $39 Monthly Subscription',
  },
  yearly: {
    amount: 39900,
    label: 'Annual Subscription',
  },
  annual499: {
    amount: 49900,
    label: 'Annual Subscription',
  },
  annual449: {
    amount: 44900,
    label: 'Annual Subscription',
  },
  'yearly-30-day-trial': {
    amount: 0,
    label: '30-Day Free Trial, Then $299 Annual Subscription, Renews at $399',
  },
  yp199: {
    amount: 19900,
    label: 'Young Professional Subscription',
  },
  yp225: {
    amount: 22500,
    label: 'Young Professional Subscription',
  },
  'all-access': {
    amount: 74900,
    label: 'All-Access Subscription',
  },
  pro: {
    amount: 99900,
    label: 'The Information Pro Subscription',
  },
};

function updateStripePaymentRequestButton(plan) {
  var planData = plan;

  if (typeof planData === 'string') {
    planData = planDataObj[plan];
  }

  if (!planData || typeof planData != 'object') {
    log('There was a problem processing this offer. Please try again.');
    return;
  }

  stripePaymentRequest.update({
    total: planData,
  });
}

document.addEventListener('script-loaded:stripe', function () {
  // Return if there is already a paymentRequestButton
  // Return if stripe library is not loaded
  if (stripePaymentRequest || typeof stripe === 'undefined') {
    log('Stripe not found or stripePaymentRequest already initialized. Returning.');
    return;
  }

  // Button config
  stripePaymentRequest = stripe.paymentRequest({
    country: 'US',
    currency: 'usd',
    total: {
      label: stripePaymentRequestLabel || 'Subscription to The Information',
      amount: stripePaymentRequestAmount || 0,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  });

  let paymentRequestButton = elements.create('paymentRequestButton', {
    paymentRequest: stripePaymentRequest,
  });

  // When testing, create mocks for Stripe behavior
  if (mockStripe) {
    log('Mocking stripe functions for payment request button');
    stripePaymentRequest.canMakePayment = async function () {
      return {
        applePay: window.mockApplePayOption,
        googlePay: window.mockGooglePayOption,
      };
    };
    paymentRequestButton.mount = function () {
      log('Payment button mounted');
      if (nativePaymentOptions.applePay) {
        $('.g-a-content').addClass('is-mounted apple');
      } else if (nativePaymentOptions.googlePay) {
        $('.g-a-content').addClass('is-mounted google');
      }
    };
  }
  // End of test code

  stripePaymentRequest.canMakePayment().then(function (result) {
    log('Checking if user has payment options availble');
    nativePaymentOptions = result;

    // set nativePaymentOptions on window for scripts outside of webpack
    window.nativePaymentOptions = nativePaymentOptions;

    if (nativePaymentOptions) {
      var paymentButtonSelector = '#payment-request-button',
        applePayEnabled = nativePaymentOptions && nativePaymentOptions.applePay != false,
        googlePayEnabled = nativePaymentOptions && nativePaymentOptions.googlePay != false;

      if (!$(paymentButtonSelector).length) {
        return;
      }

      if (applePayEnabled || googlePayEnabled) {
        log('Google or apple pay enabled. Show tabs and mount the button');
        $('.tabbed-payment-ui nav').removeClass('hidden');
        $('.g-a-content').fadeIn().addClass('active');
        paymentRequestButton.mount(paymentButtonSelector);
      } else {
        log('User does not have google or apple pay enabled');
        $('.cc-content').fadeIn().addClass('active');
        $(paymentButtonSelector).hide();
      }

      if (applePayEnabled) {
        log('Apple pay enabled');
        $('.branded-payment-icon').addClass('fa-apple');
        stripePaymentType = 'apple_pay';
      } else if (googlePayEnabled) {
        log('Google pay enabled');
        $('.branded-payment-icon').addClass('fa-google');
        stripePaymentType = 'google_pay';
      }
    } else {
      log('User does not have google or apple pay enabled');
      $('.cc-content').fadeIn().addClass('active');
    }
  });

  stripePaymentRequest.on('token', async function (event) {
    try {
      // this needs to be wrapped up
      const response = await submitStripeForm(event.token.id, null, stripePaymentType);
      if (response.message == 'success') {
        // Report to the browser that the payment was successful, prompting
        // it to close the browser payment interface.
        event.complete('success');
      } else {
        // Report to the browser that the payment failed, prompting it to
        // re-show the payment interface, or show an error message and close
        // the payment interface.
        event.complete('fail');
      }
    } catch (error) {
      event.complete('fail');
    }
  });
});

export { nativePaymentOptions, updateStripePaymentRequestButton };
